import React, { useEffect, useState } from "react";
import GalleryBanner from "../components/gallery/GalleryBanner";
import GalleryGrid from "../components/gallery/GalleryGrid";
import { useLocation } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import {
  useGalleryBannerContext,
  useGalleryImageContext,
} from "../context/GalleryContext";
import { fetchGalleryBanner, fetchGalleryImage } from "../api/GalleryApi";
import { dynamicFailed } from "../hooks/useToast";

interface IGalleryID {
  id: number;
}

const GalleryView = () => {
  const location = useLocation();
  const { setLoading } = useLoader();
  const { galleryBannerData, setGalleryBannerData } = useGalleryBannerContext();
  const { galleryImageData, setGalleryImageData } = useGalleryImageContext();
  const [galleryId, setGalleryId] = useState<IGalleryID>({
    id: 0,
  });

  useEffect(() => {
    if (location.state) {
      setGalleryId(location.state);
    }
    window.scrollTo(0, 0);
  }, [location.state]);

  useEffect(() => {
    if (galleryBannerData.length === 0 || galleryImageData.length === 0) {
      Promise.all([fetchGalleryBanner(), fetchGalleryImage()])
        .then(([GalleryBannerData, GalleryImageData]) => {
          setGalleryBannerData(GalleryBannerData);
          setGalleryImageData(GalleryImageData);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          dynamicFailed(error.response.data.error.message);
        });
    }
  }, [
    galleryBannerData.length,
    galleryImageData.length,
    setGalleryBannerData,
    setGalleryImageData,
    setLoading,
  ]);
  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
      >
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            <div className="inner_wrapper">
              <div className="sidebar_content full_width custom-sidebar_content">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="785"
                  className="elementor elementor-785"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <GalleryBanner />
                      <GalleryGrid id={galleryId.id} />
                      {/* <AlbumsGrid/> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default GalleryView;
